var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SignupForm',{attrs:{"fromPage":_vm.fromPage},on:{"signupSuccess":_vm.handleSignupSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }